import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

const RootWrapper = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  const isSignInPage = location.pathname === "/sign_in";

  useEffect(() => {
    const rootElement = document.getElementById("root");
    const myHomeyApp = document.querySelector(".my-homey-app");

    if (isSignInPage) {
      rootElement?.classList.add("justify-center");
      myHomeyApp?.classList.add("max-w-[1920px]");
    } else {
      rootElement?.classList.remove("justify-center");
      myHomeyApp?.classList.remove("max-w-[1920px]");
    }
  }, [isSignInPage]);

  return children;
};

export default RootWrapper;
